// patientSearchSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    "user_id": '',
    "user_name": '',
    "user_name_domain": '',
    "first_name": '',
    "last_name": '',
    "middle_name": '',
    "email_address": '',
    "email_address_domain": '',
    "age":'',
    "status":[],
    "sub_division_name":'',
    "primary_identifier":'',
    "secondary_identifier":'',
    "dob_day":'',
    "dob_month":'',
    "dob_year":'',

    "user_id_inverse": '',
    "user_name_inverse": '',
    "first_name_inverse": '',
    "last_name_inverse": '',
    "middle_name_inverse": '',
    "email_address_inverse": '',
    "age_inverse":'',
    "status_inverse":'',
    "sub_division_name_inverse":'',
    "primary_identifier_inverse":'',
    "secondary_identifier_inverse":'',
    "dob_inverse":'',
    "match": false,
    "patsearchApplied": false,

};

const patientSearchSlice = createSlice({
    name: 'patientSearch',
    initialState,
    reducers: {
        setPatientSearch(state, action) {
            return { ...state, ...action.payload };
        },
        resetPatientSearch(state) {
            return { ...initialState, patsearchApplied: false }; // Reset state and flag
        },
        setPatSearchApplied(state) {
            state.patsearchApplied = true; // Directly set searchApplied to true
        },
    },
});

export const { setPatientSearch, resetPatientSearch,setPatSearchApplied } = patientSearchSlice.actions;

export default patientSearchSlice.reducer;